import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Open question, please help",
  "description": "",
  "published": "2009-11-04T00:00:00.000Z",
  "redirect_from": ["/blog/open-question-please-help/swizec/801"],
  "categories": "food for thought, Morality, Religion and Spirituality, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ok so it's actually two questions:`}</p>
    <ol>
      <li parentName="ol">{`Why does viewing morality (and related) as a set of arbitrary rules always seem to get me in trouble?`}</li>
      <li parentName="ol">{`Could you suggest some reading material so I could learn what the fuck the word 'offensive' is supposed to mean? It feels like a very alien concept and I would rather not keep clashing with my environment about it.`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/9933fca5-8a9f-4251-b7a3-dda660297356/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=9933fca5-8a9f-4251-b7a3-dda660297356",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      